<template>
    <v-card flat tile outlined style="overflow:hidden">
        <v-card-title>
            <span> 계약서 정보 </span>
            <v-spacer />
            <template v-if="value.isSigned">
                <employment-contract-view v-bind="{ value }">
                    <template #activator="{ attrs, on }">
                        <v-btn small text outlined class="my-n10" v-bind="attrs" v-on="on">
                            <span> 계약서 보기 </span>
                        </v-btn>
                    </template>
                </employment-contract-view>
            </template>
            <template v-else>
                <employment-form-view v-bind="{ value: value.form }">
                    <template #activator="{ attrs, on }">
                        <v-btn small text outlined class="my-n10" v-bind="attrs" v-on="on">
                            <span> 계약서 보기 </span>
                        </v-btn>
                    </template>
                </employment-form-view>
            </template>
        </v-card-title>
        <vertical-form-table
            v-bind="{
                mode: 'view',
                value,
                items,
                style: 'margin-bottom: -1px',
            }"
        >
        </vertical-form-table>
    </v-card>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import EmploymentContractView from "@/components/dashboard/common/employment/contract/employment-contract-view.vue";
import EmploymentFormView from "@/components/dashboard/company/employment/form/employment-form-view.vue";

export default {
    components: {
        VerticalFormTable,
        EmploymentContractView,
        EmploymentFormView,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
    },
    computed: {
        items() {
            return [
                {
                    key: "subject",
                    term: "계약명",
                },
                {
                    key: "form.name",
                    term: "계약서명",
                },
                {
                    key: "isSigned",
                    term: "서명상태",
                    formatter: (isSigned) => (isSigned ? "서명 완료" : "서명 대기"),
                },
                {
                    key: "signedAt",
                    term: "서명일시",
                    type: "datetime",
                    data_default: "-",
                },
                ...this.value.fields_employee.reduce(
                    (items, item) =>
                        item.type != EMPLOYMENT_FIELD_TYPES.FILE.value
                            ? items
                            : [
                                  ...items,
                                  {
                                      term: `${item.term}`,
                                      data: item.file ? [item.file] : "-",
                                      type: item.file ? "file-chips" : undefined,
                                  },
                              ],
                    []
                ),
            ].map((item) => ({
                ...item,
                headerProps: {
                    style: "width: 100px",
                },
            }));
        },
    },
};
</script>

<style></style>
